import { isMobile } from "./deviceFilter";
import { languageFilter } from "./languageFilter";
import { reffererFilter } from "./referrerFilter";
import { queryFilter } from "./queryFilter";
import { contactFilter } from "./contactFilter";
import { urlFilter } from "./urlFilter";
export var filterRepository = {} as any;

filterRepository["device"] = {
    fn: isMobile,
    name: "DeviceFilter",
    params: { device: "" },
    paramsDescription: { device: "What type of device is being used (phone/desktop)" },
};

filterRepository["language"] = {
    fn: languageFilter,
    name: "LanguageFilter",
    params: { language: "" },
    paramsDescription: { language: "What language to check" },
};

filterRepository["refferer"] = {
    fn: reffererFilter,
    name: "ReffererFilter",
    params: { link: "" },
    paramsDescription: { link: "Only handle certain refferer" },
};
filterRepository["urlFilter"] = {
    fn: urlFilter,
    name: "UrlFilter",
    params: { urls: "" },
    paramsDescription: {
        urls: "Kommaseparerad lista med sökvägar att inte trigga på (ex. /home/42,/home/43,/store), fungerar även med wildcards ( /home/* )",
    },
};
filterRepository["queryString"] = {
    fn: queryFilter,
    name: "QueryFilter",
    params: { query: "" },
    paramsDescription: { query: "Gives the value of the query searched?" },
};

filterRepository["contact"] = {
    fn: contactFilter,
    name: "ContactFilter",
    params: { contactType: "" },
    paramsDescription: { contactType: "only activate on selected contact type (KNOWN / UNKNOWN)" },
};
